import { Component, forwardRef, Input, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

export const V4_INPUT_NUMBER_WITH_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => V4InputNumberWithControlComponent),
  multi: true,
};

@Component({
  selector: "v4-input-number-with-control",
  templateUrl: "./input-number-with-control.component.html",
  styleUrls: ["./input-number-with-control.component.scss"],
  providers: [V4_INPUT_NUMBER_WITH_CONTROL_VALUE_ACCESSOR],
})
export class V4InputNumberWithControlComponent implements OnInit, ControlValueAccessor {
  @Input() min = 0;
  _registerOnChange: (value: any) => void = (_: any) => {};

  value;
  constructor() {}

  ngOnInit() {}

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: any): void {
    console.log("inner write value: ", value);
    this.value = value;
  }

  onValueChange(value) {
    console.log("value chagne: ", value);
    this.value = value || 0;

    if (this.value < this.min) {
      this.value = this.min;
    }
    this._registerOnChange(this.value);
  }

  // onControl(ope: "+" | "-") {
  //   if (ope === "+") {
  //     this.value = this.value + 1 || 0;
  //   } else {
  //     this.value = this.value - 1 || 0;
  //   }
  //   this._registerOnChange(this.value);
  // }
}
